import { useList } from '@refinedev/core';

import { AvailableResources } from '@/config';
import { DEFAULT_STALE_TIME } from '@/constants';
import type { ListResponse } from '@/utils/types';

import type { Region } from './types';

type Props = {
  enabled?: boolean;
};
const useGetRegions = ({ enabled }: Props = {}) => {
  const { data, isLoading, fetchStatus, refetch } = useList<
    ListResponse<Region>
  >({
    resource: AvailableResources.REGIONS,
    pagination: {
      mode: 'off'
    },
    queryOptions: {
      enabled,
      // Regions are effectively static for a session. Without a stale time the
      // query refetches on every new observer mount, which (combined with
      // keepPreviousData) flips fetchStatus to 'fetching' and flickers the
      // region selector. Cache for 5 minutes to avoid the redundant calls.
      staleTime: DEFAULT_STALE_TIME
    }
  });

  return {
    data: (data?.data as unknown as ListResponse<Region>)?.items ?? [],
    isLoading,
    fetchStatus,
    refetch
  };
};

export default useGetRegions;
